import { App } from './App';
new App().start().catch(err => {
  throw err;
});